"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.errorHandle = exports.Application = void 0;

var ReactDOM = require("react-dom");

var simple_master_page_1 = require("./masters/simple-master-page");

var main_master_page_1 = require("./masters/main-master-page");

var React = require("react");

var my_service_1 = require("./services/my-service");

var chitu_react = __importStar(require("maishu-chitu-react"));

var ui = __importStar(require("maishu-ui-toolkit"));

var maishu_ui_toolkit_1 = require("maishu-ui-toolkit");

var app = null;

function startup(_x) {
  return _startup.apply(this, arguments);
}

function _startup() {
  _startup = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(requirejs) {
    var _masterPages$default;

    var createMasterPages, _createMasterPages, service, config, masterPages;

    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _createMasterPages = function _createMasterPages3() {
              _createMasterPages = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(app) {
                var mainProps, simplePorps, r;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        mainProps = {
                          app: app
                        };
                        simplePorps = {
                          app: app
                        };
                        _context2.next = 4;
                        return Promise.all([renderElement(simple_master_page_1.SimpleMasterPage, simplePorps, document.getElementById('simple-master')), renderElement(main_master_page_1.MainMasterPage, mainProps, document.getElementById('main-master'))]);

                      case 4:
                        r = _context2.sent;
                        return _context2.abrupt("return", {
                          simple: r[0],
                          default: r[1]
                        });

                      case 6:
                      case "end":
                        return _context2.stop();
                    }
                  }
                }, _callee2);
              }));
              return _createMasterPages.apply(this, arguments);
            };

            createMasterPages = function _createMasterPages2(_x3) {
              return _createMasterPages.apply(this, arguments);
            };

            console.assert(requirejs != null);
            app = new Application(requirejs, document.getElementById('simple-master'), document.getElementById('main-master'), document.getElementById('blank-master'));
            service = app.createService(my_service_1.MyService);
            _context3.next = 7;
            return service.config();

          case 7:
            config = _context3.sent;
            maishu_ui_toolkit_1.Less.renderByRequireJS("admin_style_default");
            console.assert(config.menuItems != null);
            _context3.next = 12;
            return createMasterPages(app);

          case 12:
            masterPages = _context3.sent;

            (_masterPages$default = masterPages.default).setMenu.apply(_masterPages$default, _toConsumableArray(config.menuItems));

            requirejs(["clientjs_init.js"], function (initModule) {
              console.assert(masterPages.default != null);

              if (initModule && typeof initModule.default == 'function') {
                var args = {
                  app: app,
                  mainMaster: masterPages.default,
                  requirejs: requirejs
                };
                var result = initModule.default(args);

                if (result != null && result.then != null) {
                  result.then(function () {
                    app.run();
                  });
                  return;
                }
              }

              app.run();
            });

          case 15:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _startup.apply(this, arguments);
}

exports.default = startup;

function renderElement(componentClass, props, container) {
  return new Promise(function (resolve) {
    props.ref = function (e) {
      if (!e) return;
      resolve(e);
    };

    var element = React.createElement(componentClass, props);
    ReactDOM.render(element, container);
  });
}

var Application = /*#__PURE__*/function (_chitu_react$Applicat) {
  _inherits(Application, _chitu_react$Applicat);

  var _super = _createSuper(Application);

  function Application(requirejs, simpleContainer, mainContainer, blankContainer) {
    var _this;

    _classCallCheck(this, Application);

    _this = _super.call(this, {
      container: {
        simple: simpleContainer,
        default: mainContainer,
        blank: blankContainer
      }
    });

    _this.error.add(function (sender, error) {
      return errorHandle(error, _assertThisInitialized(_this));
    });

    _this.pageCreated.add(function (sender, page) {
      return _this.onPageCreated(page);
    });

    return _this;
  }

  _createClass(Application, [{
    key: "onPageCreated",
    value: function () {
      var _onPageCreated = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(page) {
        var pageClassName;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // let lessFilePath: string;
                // if (page.name.indexOf(":")) {
                //     let arr = page.name.split(":");
                //     lessFilePath = `modules/${arr[1]}.less`;
                // }
                // else {
                //     lessFilePath = `modules/${page.name}.less`;
                // }
                // lessFilePath = `${page.name}.less`;
                pageClassName = page.name.split("/").filter(function (o) {
                  return o != "";
                }).join("-");
                page.element.className = "admin-page ".concat(pageClassName); // let stationPath = getStationPath(page.name);
                // let myService = this.createService(MyService);
                // let files = await myService.files(stationPath);
                // let pageLessFiles = files.filter(o => o.startsWith("modules") && o.endsWith(".less"));
                // if (pageLessFiles.indexOf(lessFilePath) >= 0) {
                //     this.loadPageLess(lessFilePath, pageClassName, stationPath);
                // }

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function onPageCreated(_x2) {
        return _onPageCreated.apply(this, arguments);
      }

      return onPageCreated;
    }()
  }]);

  return Application;
}(chitu_react.Application);

exports.Application = Application;
var errorMessages = {
  "726": "没有权限访问"
};

function errorHandle(error, app) {
  error.message = errorMessages[error.name] || error.message;

  if (error.name == "718" && app != null) {
    // app.redirect("login");
    location.hash = "#login";
    return;
  }

  ui.alert({
    title: "错误",
    message: error.message
  });
}

exports.errorHandle = errorHandle;
